import React, { createRef, useEffect, useState } from "react";
import Collapse from "@material-ui/core/Collapse";

import servicesImage from "../../images/product-services.svg";
import searchImage from "../../images/search.svg";
// import { isNullOrUndefined } from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";

import ChannelBox from "./ChannelBox";
// import ChatStartButton from "./ChatStartButton";
// import ContactFormButton from "./ContactFormButton";
import InitialChannelHeader from "./InitialChannelHeader";

import "./InitialFormStyleSheet.css";

function InitialChannelFormDetails(props) {
  const [components, setComponents] = useState([]);

  // const [show, setShow] = useState(false);

  useEffect(() => {
    const items = s360ConfigService.config?.channels
      ? s360ConfigService.config.channels.sort(
          (i1, i2) => i1.selposition - i2.selposition
        )
      : [];

    setComponents(
      items.map((item) => {
        const ref = createRef();

        return {
          item,
          ref,
          component: (
            <ChannelBox
              ref={ref}
              item={item}
              key={item.selposition}
              moveToNextScreen={() => props.moveToNextScreen()}
            />
          ),
        };
      })
    );
  }, [s360ConfigService?.config?.channels]);

  const containerStyle = () => {
    return {};
  };

  const allConversationStyle = () => {
    return s360ConfigService.config?.customDesign
      ?.conversationListAllConversation;
  };

  // Sort form items by selposition.
  return (
    <>
      <div className="s360-initial-channel-body">
        <div
          className="s360-initial-channel-container"
          style={containerStyle()}
        >
          {s360ConfigService.config.configDetails?.channelIntroText && (
            <div
              style={{
                marginBottom: "2rem",
                fontWeight: 600,
                textAlign: "left",
              }}
            >
              {s360ConfigService.config.configDetails.channelIntroText}
            </div>
          )}
          <div className="s360-initial-channel-list-item">
            <Collapse
              style={{
                minHeight: s360ConfigService.config.configDetails.hideFAQ
                  ? 237
                  : 150,
                visibility: "unset",
                transitionDuration: "200ms",
              }}
            >
              <div>
                <span>
                  {components.map((component) => (
                    <>{component.component}</>
                  ))}
                </span>
              </div>
            </Collapse>
          </div>
          {/* {components.length > 5 && (
            <div className="s360-initial-channel-list-items">
              <a onClick={() => setShow(currentShow => !currentShow)}
                style={{ textDecoration: 'none', cursor: "pointer" }}>
                {show ? 'View less' : 'View more'}
              </a>
            </div>
          )} */}
        </div>
        {/* {!s360ConfigService.config.configDetails.hideFAQ && (
          <div
            className="s360-initial-channel-faq-container"
            style={containerStyle()}
          >
            <div
              className="s360-initial-channel-faq-list"
              style={allConversationStyle()}
            >
              <div className="s360-initial-channel-faq-list-item"> FAQ</div>
              <div className="s360-initial-channel-faq-list-img">
                <img
                  style={{
                    width: "20px",
                    height: "20px",
                    marginLeft: "8px",
                    cursor: "pointer",
                  }}
                  src={searchImage}
                  alt="/"
                />
              </div>
            </div>
            <div className="s360-initial-channel-faq-list-item">
              <div>
                <span>
                  <a
                    href=""
                    className="styles_channel__396ZG styles_whatsapp__80fGh"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      paddingBottom: "14px",
                      width: "100%",
                      marginBottom: "3%",
                      marginLeft: "-16px",
                      paddingLeft: "25px",
                    }}
                  >
                    <div className="styles_channelIcon__1i0qs styles_whatsapp__80fGh">
                      <img
                        className="channelBoxBgColor"
                        src={servicesImage}
                        width="20"
                        height="24"
                        alt=""
                      />
                    </div>
                    <p className="styles_channelName__Q8vJ4">
                      Product &amp; Services
                    </p>
                  </a>
                </span>
              </div>
            </div>
          </div>
        )} */}
        {/* <div>
          {s360ConfigService.config.startChatText && 
          <button className="s360-initial-channel-btn" onClick={handleRedirect} style={props.config?.customDesign?.initialFormStartButton}>
            <span className="s360-initial-form-start-button-span-text">
              {isNullOrUndefined(s360ConfigService.config.startChatText) ? "Let's Chat" : s360ConfigService.config.startChatText}
            </span>
          </button>}
        </div> */}
      </div>
    </>
  );
}

export default InitialChannelFormDetails;
